/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type IconButtonReminderActions_Reminder = {
    readonly _id: string;
    readonly sendAt: unknown | null;
    readonly patient: {
        readonly _id: string;
    } | null;
    readonly oid_appointment: string | null;
    readonly " $refType": "IconButtonReminderActions_Reminder";
};
export type IconButtonReminderActions_Reminder$data = IconButtonReminderActions_Reminder;
export type IconButtonReminderActions_Reminder$key = {
    readonly " $data"?: IconButtonReminderActions_Reminder$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"IconButtonReminderActions_Reminder">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IconButtonReminderActions_Reminder",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oid_appointment",
      "storageKey": null
    }
  ],
  "type": "Reminder",
  "abstractKey": null
};
})();
(node as any).hash = '29785f4e65b6072605152e4f64366f59';
export default node;
